export const routeNames = {
  main: "Home",
  privacy: "Privacy",
  feedback: "Feedback",
};
